export {};

function preloadImages() {
    const images = [
        'recipient-loading-failed.png',
        'audience-list-empty.svg',
        'audienceCount-active.png',
        'recipients-grayscale.svg',
        'audiences-no-integration-state.png',
        'comcenter-error-message.png',
        'grid-thumbnail.svg',
        'notification-empty-state.png',
        'recipient-loading-failed.png'
    ];
    images.forEach((name, idx) =>
        import(`../assets/images/${name}`)
            .then(module => {
                const src = module.default;
                const img1 = new Image();
                img1.src = src;
            })
            .catch(error => {
                console.warn(`failed to preload image ${images[idx]}`, error);
            })
    );
}

preloadImages();
